import graphqlClient from "../../../api/axios_interceptor";
import { sendTenantOtpMutation, verifyTenantOtpMutation } from "../../../api/graphql/tenantApp/queries/authentication";
import { SEND_TENANT_OTP, VERIFY_TENANT_OTP } from "../actions/actionTypes";
import { updateActionErrors } from "../middleware/updateErrors";


export const sendTenantOtpMiddleware = async (action) => {
    try{
        const payload = action.payload;
        const query = sendTenantOtpMutation(payload.confirmationChannel, payload.phoneNumber, payload.email);
        await graphqlClient({
            data: {
                query
            }
        }).then((queryResult) =>{
            if (queryResult.data.errors){
                action = updateActionErrors(action, queryResult.data.errors)
            }else if(!queryResult.data.data.sendTenantOtp.success){
                action = updateActionErrors(action, queryResult.data.data.sendTenantOtp.errorMessage)
            }else{
                action.payload = {
                    ...action.payload,
                    ...queryResult.data.data.sendTenantOtp,
                }
            }
        })

    }catch (error){
        console.error(error)
        action = updateActionErrors(action, error)
    }
    return action
}

export const verifyTenantOtpMiddleware = async (action) => {
    try{
        const payload = action.payload;
        const query = verifyTenantOtpMutation(payload.otpCode, payload.phoneNumber, payload.email);
        await graphqlClient({
            data: {
                query
            }
        }).then((queryResult) =>{
            if (queryResult.data.errors){
                action = updateActionErrors(action, queryResult.data.errors)
            }else if(!queryResult.data.data.verifyTenantOtp.success){
                action = updateActionErrors(action, queryResult.data.data.verifyTenantOtp.errorMessage)
            }else{
                action.payload = {
                    ...action.payload,
                    ...queryResult.data.data.verifyTenantOtp,
                }
            }
        })

    }catch (error){
        console.error(error)
        action = updateActionErrors(action, error)
    }
    return action
}

export const tenantAuthMiddleware = storeAPI => next => async action =>{
    switch(action.type){
        case SEND_TENANT_OTP:
            action = await sendTenantOtpMiddleware(action);
            break
        case VERIFY_TENANT_OTP:
            action = await verifyTenantOtpMiddleware(action);
            break
    }
    return next(action)
}